module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/beian-icon.58f55c5c.png";